import React, { useMemo } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { isTrue } from "../../../../../Utils/filter";

const states = [
    {
        label: "未参与",
        value: 0,
        className: style.state
    },
    {
        label: "已参与",
        value: 1,
        className: style.doing
    }
];

interface Props {
    status: BooleanValue;
}
export default function ListStatus({ status }: Props) {
    const state = useMemo(() => {
        if (!isTrue(status)) {
            return 0;
        }
        if (isTrue(status)) {
            return 1;
        }
    }, [status]);

    const itemData = useMemo(
        () => states.find(item => item.value === state),
        [state]
    );

    return (
        <div className={classNames(style.root, itemData?.className)}>
            {itemData?.label}
        </div>
    );
}
